var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tile',{staticClass:"c-tile--logo",attrs:{"product":_vm.product}},[_c('v-product-image',{staticClass:"c-tile__image",attrs:{"product":_vm.product,"type":_vm.ImageType.SQUARE_MINI}}),_c('v-badge',{staticClass:"c-tile__badge c-tile__badge--left",attrs:{"product":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }